document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.querySelector('cart-drawer');
  var cartCountBubble = document.querySelector('.cart-count-bubble');
  var headerIconCart = document.querySelector('.header__icon--cart');
  //console.log(cartCountBubble);
  // Function to handle button click
  window.handleButtonClick = function (button) {
    var variantId = button.getAttribute('variant');
    addToCart(variantId);
  }; 

  function addToCart(variantId) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
  
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(formData),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        updateCartCount();
        if (cartDrawerHasItems()) {
          updateCartDrawer();
        } else {
          //window.location.reload();
          updateCartDrawerEmpty();
        }
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
  }

  function updateCartDrawer() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function updateCartDrawerEmpty() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['#CartDrawer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
        
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
          document.querySelector('cart-drawer').classList.remove('is-empty');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cartData) {
        var itemCount = cartData.item_count || 0;
      
        if (headerIconCart) {
          //cartCountBubble.classList.remove('visually-hidden');
          headerIconCart.innerHTML =
            '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"></path></svg></span>' +
            '<span class="visually-hidden">Cart</span>' +
            '<div class="cart-count-bubble "><span aria-hidden="true">' +
            itemCount +
            '</span><span class="visually-hidden">' +
            itemCount +
            'items</span>';
        }
      
        // Check if there are items in the cart before updating
        if (itemCount > 0) {
          cartDrawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
        } else {
          cartDrawer.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        }
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
  }

  function cartDrawerHasItems() {
    const cartDrawerItems = document.querySelector('.cart-drawer__form .drawer__contents .cart-items');
    return cartDrawerItems && cartDrawerItems.querySelectorAll('tbody tr').length > 0;
  }
});